import React from 'react'
import PropTypes from 'prop-types';

import { ArrowContainer } from './styles'

const Arrow = (props) => {
  const { align, side } = props;
  return (
    <ArrowContainer className={`side-${side} align-${align}`}>
      <svg width="20" height="12" viewBox="0 0 5.726 3.546">
        <path
          transform="matrix(.11682 0 0 .08094 -1.277 -2.63)"
          d="M12.787 74.449 35.435 35.22l22.65 39.229"
        />
      </svg>
    </ArrowContainer>
  );
};

Arrow.propTypes = {
  align: PropTypes.string,
  side: PropTypes.string,
};

export default Arrow;
